import client from 'client';
import { useMutation } from 'react-query';

const fetchVirtualSessionCheckout = (eventId: number, sessionId: number) =>
    client().put(`/api/v2/agenda/events/${eventId}/sessions/${sessionId}/checkout`);

const useVirtualSessionCheckout = (eventId: number) => {
    const { mutateAsync: virtualSessionCheckout } = useMutation((sessionId: number) =>
        fetchVirtualSessionCheckout(eventId, sessionId)
    );

    return { virtualSessionCheckout };
};

export default useVirtualSessionCheckout;
